"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var R = _interopRequireWildcard(require("ramda"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

var _default = function _default(FroalaEditor) {
  return [{
    provider: 'wistia',
    test_regex: /^.*wistia.com\/medias\/.*/,
    url_regex: /^.*wistia.com\/medias\/(.*)$/,
    url_text: 'https://fast.wistia.net/embed/iframe/$1?videoFoam=true',
    html: '<iframe width="640" height="360" src="{url}" frameborder="0" allowfullscreen></iframe>'
  }, {
    provider: 'widen',
    test_regex: /^https:\/\/.*.widen.net\/.*/,
    url_regex: /^https:\/\/(.*).widen.net\/(.*)$/,
    url_text: 'https://$1.widen.net/$2',
    html: '<iframe width="640" height="360" src="{url}" frameborder="0" allowfullscreen></iframe>'
  }].forEach(function (providerInfo) {
    return R.when(function (providers) {
      return providers.find(R.propEq('provider', providerInfo.provider)) === undefined;
    }, function (providers) {
      return providers.push(providerInfo);
    })(FroalaEditor.VIDEO_PROVIDERS);
  });
};

exports.default = _default;